// extracted by mini-css-extract-plugin
export default {"Carousel__container":"style_Carousel__container__VRCJh","Carousel__navPaginations":"style_Carousel__navPaginations__aTAlo","Carousel__elect":"style_Carousel__elect__DRo3C"};